/* Scroll-snap carousel shared by the LS top-sellers and testimonials sections. */
class LSCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-carousel-track]');
    this.prev = root.querySelector('[data-carousel-prev]');
    this.next = root.querySelector('[data-carousel-next]');

    if (!this.track) return;

    this.onScroll = this.updateButtons.bind(this);

    if (this.prev) this.prev.addEventListener('click', () => this.scrollByPage(-1));
    if (this.next) this.next.addEventListener('click', () => this.scrollByPage(1));

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);

    this.updateButtons();
  }

  get step() {
    const item = this.track.querySelector('[data-carousel-item]');
    if (!item) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  scrollByPage(direction) {
    this.track.scrollBy({ left: this.step * direction, behavior: 'smooth' });
  }

  updateButtons() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const atStart = this.track.scrollLeft <= 1;
    const atEnd = this.track.scrollLeft >= maxScroll - 1;
    const noOverflow = maxScroll <= 1;

    if (this.prev) this.prev.disabled = atStart || noOverflow;
    if (this.next) this.next.disabled = atEnd || noOverflow;
  }
}

function initLSCarousels(scope) {
  (scope || document).querySelectorAll('[data-ls-carousel]').forEach((root) => {
    if (root.dataset.lsCarouselReady === 'true') return;
    root.dataset.lsCarouselReady = 'true';
    new LSCarousel(root);
  });
}

initLSCarousels();

document.addEventListener('shopify:section:load', (event) => initLSCarousels(event.target));

// Related products are fetched and swapped in after load, so neither trigger
// above fires for them. The ready-guard in initLSCarousels makes this a no-op
// for carousels that are already running.
if (typeof MutationObserver !== 'undefined') {
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('[data-ls-carousel]') || node.querySelector?.('[data-ls-carousel]')) {
          initLSCarousels(node.parentNode || document);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
